var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', [_c('div', {
    staticClass: "grid-toolbar"
  }, [_vm.$getOperateAuth('admin_manage_users') ? _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": _vm.activate
    }
  }, [_vm._v(_vm._s(_vm.selection[0] && _vm.selection[0].is_active ? '禁用' : '激活'))]) : _vm._e(), _vm.$getOperateAuth('admin_manage_users') ? _c('Button', {
    attrs: {
      "disabled": !_vm.selection.some(function (s) {
        return s.is_active;
      })
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("编辑")]) : _vm._e(), _vm.$getOperateAuth('admin_manage_users') ? _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1 || _vm.selection[0].is_active
    },
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("删除")]) : _vm._e(), _vm.$getOperateAuth('admin_manage_users') ? _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": _vm.resetPass
    }
  }, [_vm._v("重置密码")]) : _vm._e(), _vm.$getOperateAuth('admin_manage_groups') ? _c('Button', {
    attrs: {
      "disabled": !_vm.selection.some(function (s) {
        return s.is_active;
      })
    },
    on: {
      "click": _vm.updateGroup
    }
  }, [_vm._v("编辑角色")]) : _vm._e(), _vm.$getOperateAuth('admin_manage_products') ? _c('Button', {
    attrs: {
      "disabled": !_vm.selection.some(function (s) {
        return s.is_active;
      })
    },
    on: {
      "click": _vm.updateProducts
    }
  }, [_vm._v("编辑产品范围")]) : _vm._e(), _c('Form', {
    staticClass: "search-form",
    attrs: {
      "label-width": 70,
      "inline": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "角色"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.changeRole
    },
    model: {
      value: _vm.selectedRoleId,
      callback: function callback($$v) {
        _vm.selectedRoleId = $$v;
      },
      expression: "selectedRoleId"
    }
  }, _vm._l(_vm.roleList, function (item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "帐号状态"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.changeStatus
    },
    model: {
      value: _vm.searchStatus,
      callback: function callback($$v) {
        _vm.searchStatus = $$v;
      },
      expression: "searchStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("未激活")]), _c('Option', {
    attrs: {
      "value": "全部"
    }
  }, [_vm._v("全部")])], 1)], 1)], 1)], 1), _c('Table', {
    ref: "grid",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.data,
      "loading": _vm.pageLoading
    },
    on: {
      "on-sort-change": _vm.onSortChange,
      "on-selection-change": _vm.onSelectionChange,
      "on-row-click": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "btns",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c('Button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.viewDetails(row);
            }
          }
        }, [_vm._v("详情")])];
      }
    }])
  }), _c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Page', {
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onCurrentPageChange
    }
  }), _c('RadioGroup', {
    staticClass: "page-selector",
    attrs: {
      "type": "button"
    },
    model: {
      value: _vm.pageSize,
      callback: function callback($$v) {
        _vm.pageSize = $$v;
      },
      expression: "pageSize"
    }
  }, _vm._l([10, 25, 50, 100], function (num) {
    return _c('Radio', {
      key: num,
      attrs: {
        "label": num
      }
    }, [_vm._v(_vm._s(num))]);
  }), 1)], 1), _c('UserInfoModal', {
    attrs: {
      "title": "编辑用户",
      "user": _vm.selectUser
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showAddEditUser,
      callback: function callback($$v) {
        _vm.showAddEditUser = $$v;
      },
      expression: "showAddEditUser"
    }
  }), _c('UpdateGroupModal', {
    attrs: {
      "title": "编辑角色",
      "user": _vm.selectUser
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showUpdateModal,
      callback: function callback($$v) {
        _vm.showUpdateModal = $$v;
      },
      expression: "showUpdateModal"
    }
  }), _c('UpdateGroupModal', {
    attrs: {
      "title": "激活用户并分配角色",
      "user": _vm.selection[0],
      "from": "active"
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showActiveUser,
      callback: function callback($$v) {
        _vm.showActiveUser = $$v;
      },
      expression: "showActiveUser"
    }
  }), _c('UpdateProductsModal', {
    attrs: {
      "title": "编辑产品范围",
      "user": _vm.selectUser
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showProductsModal,
      callback: function callback($$v) {
        _vm.showProductsModal = $$v;
      },
      expression: "showProductsModal"
    }
  }), _c('TableDetailModal', {
    attrs: {
      "title": "用户详情",
      "visible": _vm.showTableDetail,
      "data": _vm.tableDetail,
      "columns": _vm.tableDetailColumns
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showTableDetail = $event;
      }
    }
  }), _c('ResetPassModal', {
    attrs: {
      "title": "重置密码",
      "id": _vm.toResetPassId
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showResetPass,
      callback: function callback($$v) {
        _vm.showResetPass = $$v;
      },
      expression: "showResetPass"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };